(function () {
  var MIN_DELAY = 120;
  var MAX_DELAY = 900;

  function getSyncItems(grid) {
    var selector = '.product-item, .product-item--featured-image';
    var isSlider =
      grid.classList.contains('grid--slider') || grid.hasAttribute('data-grid-slider');

    if (isSlider) {
      return Array.prototype.slice.call(grid.querySelectorAll(selector));
    }

    var style = window.getComputedStyle(grid);
    var cols = parseInt(style.getPropertyValue('--COLUMNS'), 10) || 4;
    var rows = parseInt(grid.getAttribute('data-sync-rows'), 10) || 2;
    var limit = cols * rows;

    return Array.prototype.slice.call(grid.querySelectorAll(selector)).slice(0, limit);
  }

  function getImages(items) {
    var images = [];

    items.forEach(function (item) {
      Array.prototype.slice.call(item.querySelectorAll('img')).forEach(function (img) {
        images.push(img);
      });
    });

    return images;
  }

  function initProductGridSync(grid) {
    if (!grid || grid.getAttribute('data-sync-init') === 'true') {
      return;
    }

    grid.setAttribute('data-sync-init', 'true');

    var items = getSyncItems(grid);
    var images = getImages(items);
    var revealed = false;
    var start = performance.now();

    function reveal() {
      if (revealed) {
        return;
      }

      var show = function () {
        if (revealed) {
          return;
        }

        revealed = true;
        grid.classList.add('products-sync-ready');

        Array.prototype.slice.call(grid.querySelectorAll('[data-aos]')).forEach(function (el) {
          el.classList.add('aos-animate');
        });
      };

      var elapsed = performance.now() - start;
      var remaining = Math.max(0, MIN_DELAY - elapsed);
      window.setTimeout(show, remaining);
    }

    if (!images.length) {
      reveal();
      return;
    }

    var pending = images.length;

    function done() {
      pending -= 1;
      if (pending <= 0) {
        reveal();
      }
    }

    images.forEach(function (img) {
      if (img.complete) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });

    window.setTimeout(reveal, MAX_DELAY);
  }

  function scan(root) {
    var scope = root || document;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-products-sync]'))
      .forEach(initProductGridSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches('[data-products-sync]')) {
            initProductGridSync(node);
          }

          scan(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
